import { UnorderedList, ListItem, Text } from '@chakra-ui/react';

import { RequirementsSummary } from 'shared-components';

interface IProps {
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = ['1.1', '1.2', '1.3', '2.1', '2.2', '3.1', '3.2', '3.3', '4.1', '4.2', '5.1', '5.2', '5.3'];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'1. We have to be sure your letter is authentic'}
        >
          {sectionsToShow.includes('1.1') || sectionsToShow.includes('1.2') || sectionsToShow.includes('1.3') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>
                  Your letter printed on official letter headed paper or stationary of the bank or financial institution
                </ListItem>
              ) : null}
              {sectionsToShow.includes('1.2') ? (
                <ListItem>The letterhead must include the name and logo of the bank or financial institution</ListItem>
              ) : null}
              {sectionsToShow.includes('1.3') ? (
                <ListItem>
                  The letter should include a signature and/or the official stamp or seal of the bank or institution
                </ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary uploadWarning={props.uploadComplete} title={'2. Your letter must have a valid date'}>
          <UnorderedList>
            {sectionsToShow.includes('2.1') ? <ListItem>The date must be no more than 31 days ago</ListItem> : null}
            {sectionsToShow.includes('2.2') ? (
              <ListItem>
                It is recommended that the date gives you enough time to use it for your visa application (optional){' '}
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('3.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'3. We must be able to see your connection to the bank account and relevant details'}
        >
          <UnorderedList>
            {sectionsToShow.includes('3.1') ? (
              <ListItem>
                The letter must specify your parent/guardian's name to identify them as the account holder (matching
                birth certificate)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('3.2') ? (
              <ListItem>The account number of the account must be present</ListItem>
            ) : null}
            {sectionsToShow.includes('3.3') ? (
              <ListItem>
                The currency of the funds available in the account must be indicated (e.g. British Pounds, GBP)
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('4.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'4. We must be sure the funds have been in the account for at least 28 consecutive days'}
        >
          <UnorderedList>
            {sectionsToShow.includes('4.1') ? (
              <ListItem>The letter must state the total funds available in the account</ListItem>
            ) : null}
            {sectionsToShow.includes('4.2') ? (
              <ListItem>
                The letter must confirm that account did not fall below the required amount in the past 28 days
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('5.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'5. Letter must be in English or have an English translation'}
        >
          <Text mt={4} mb={2}>
            For letters not in English:
          </Text>

          <UnorderedList>
            {sectionsToShow.includes('5.1') ? (
              <ListItem>A translation must be included with the letter</ListItem>
            ) : null}
            {sectionsToShow.includes('5.2') ? (
              <ListItem>The translation must be signed and dated by a qualified translator</ListItem>
            ) : null}
            {sectionsToShow.includes('5.3') ? (
              <ListItem>Contact details and credentials for the translator must be included</ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}
    </>
  );
}
